import SentMessageIcon from 'components/atoms/icons/sent-message-check-mark.svg?react';
import { useTranslation } from 'react-i18next';
import { DateFormatter } from 'infrastructure/functions';
import { DateFormats } from 'infrastructure/enums';
import { type FC } from 'react';
import { generateFullName } from 'utils/badgeHelpers';
import { convertSecondsToTime } from 'utils/timeHelper';
import { DOCUMENTATION_TIME_PLACEHOLDER } from 'infrastructure/consts/tables';

import s from './styles.module.scss';

import type { IActivityComments } from 'infrastructure/interfaces/i-rpm-patient-activity';

interface ReviewedItemProps {
  comment: IActivityComments;
}

const ReviewedItem: FC<ReviewedItemProps> = ({ comment }) => {
  const { t } = useTranslation();
  const actionTime = !comment?.documentationTime
    ? DOCUMENTATION_TIME_PLACEHOLDER
    : convertSecondsToTime(comment?.documentationTime);

  return (
    <li
      data-cy="comment-reviewed"
      className={s['reviewed-item']}
      key={comment.guid}
      data-new-action={comment?.newAction}
    >
      <div>
        <p className={s['documentation-time']} data-padding>
          {t('labels.documentationTime')}: <span>{actionTime}</span>
        </p>
        <div className={s['reviewed-item-wrapper']}>
          <SentMessageIcon className={s['sent-check-mark']} />
          <div>
            <p className={s['reviewed-item-title']}>
              {t('labels.readingWasReviewed')}
            </p>
            <p className={s['reviewed-item-signed-by']}>
              <span>{t('labels.electronicallySignedBy')}:</span>
              <span>
                {generateFullName(
                  comment.createdByTitle,
                  comment.createdByFirstName,
                  '',
                  comment.createdByLastName,
                  comment.createdByProfessionType,
                )}
              </span>
            </p>
          </div>
          <p className={s['reviewed-item-date']}>
            {DateFormatter({
              date: comment.createdAt,
              format: DateFormats['MM-dd-yyyy | h:mm a'],
            })}
          </p>
        </div>
      </div>
    </li>
  );
};
export default ReviewedItem;
